module.exports = __webpack_public_path__ + "static/media/redcat.d2db1cf2.png";